export default __webpack_public_path__ + "static/hw_ff_ultra-divider_schem-9fe5bcf5b06cd582b25427029e0a342e.png";